<script lang="ts" setup>   
    import '../../css/choice.css';
    import {onMounted,reactive,watch} from 'vue';
    import {GetAllergyInteraction,IInteractionInput,IInteractionLevel,IAllergyInteraction,getSeverityClass,severityLevel,
        allergyMonographType,printClass,buildSingleColumnReport,buildDoubleColumnReport,
        reportPage1Rows,reportPage2Rows,errorReturnMessage} from '../lib/Models/InteractionModel'; 

    const formData = reactive <
    {   
        interactionRetrieved: boolean, 
        drugData? : IInteractionLevel,
        allergyList? : IAllergyInteraction[],
        drugSeverityClass? : string,
        drugErrorMessage? : string,
        interactionCount: number
    }>
    ({     
        interactionRetrieved : false, 
        drugSeverityClass: "",
        drugErrorMessage: "",
        interactionCount: 0
    });
    onMounted(() => {  
    });
    const props = withDefaults( defineProps<
        {
            showDialog: boolean,
            patientID: number,
            prescriptionID?: number,
            medicationID?: number,
            medicationLevel?: number,
            displayHeight? : number,
        }>(),
        {
            showDialog: false,
            prescriptionID: 0,
            medicationID: 0,
            medicationLevel: 0,
            displayHeight : 350
        });

    watch(() => props.showDialog, (newShow,oldShow) => { 
        if ((newShow) && (newShow !== oldShow) && (!formData.interactionRetrieved)) { 
            getAllergyInteractions();
        }
    });

    const emit=defineEmits(["updateModal","updateModalAllergy"]);  

    async function getAllergyInteractions() : Promise<void> {  
        const drugInputs : IInteractionInput = {PatientID: props.patientID, PrescriptionID: props.prescriptionID, MedID: props.medicationID, MedLevel: props.medicationLevel, DisplayAllInteractions: 1};
        const respGet = await GetAllergyInteraction(drugInputs);  
        
        if (!respGet.success) {  
            formData.drugErrorMessage = respGet.error?.error ?? errorReturnMessage.allergyInteraction;
            emit('updateModal',"Unknown Drug",severityLevel.None,0);   
            return;
        } 
        formData.interactionRetrieved = true; 
        formData.drugData = respGet.success.interactionlData;
        formData.allergyList = respGet.success.allergyList; 
        formData.drugSeverityClass = getSeverityClass(respGet.success.interactionlData.minSeverityLevel);
        formData.interactionCount = formData.allergyList.filter(item => item.monographType === allergyMonographType.Allergen.toString()).length ?? 0;  
        emit('updateModal',formData.drugData.drugName,formData.drugData.minSeverityLevel,formData.interactionCount); 
        const reportingData = formData.allergyList.map(item => getAllergyReportingData(item.monographType, item.monograph));
        const reportTitle = "Allergy Interactions";
        let reportData = "";
        if (formData.allergyList?.length ?? 0 <= reportPage1Rows) {
            reportData = buildSingleColumnReport(reportTitle,formData.drugData.drugName,reportPage1Rows,reportPage2Rows,reportingData); 
        }
        else {
            reportData = buildDoubleColumnReport(reportTitle,formData.drugData.drugName,reportPage1Rows,reportPage2Rows,reportingData); 
        }
        emit('updateModalAllergy',true,reportData);  
    } 
    function getAllergyReportingData(monograph_type : string, monograph: string) : string {
        let allergyReportData = "";

        switch (monograph_type) {
            case allergyMonographType.Allergen.toString():
                allergyReportData = `<div style="${printClass.allergenMonograph}">${monograph}</div>`;
                break;
            case allergyMonographType.Ingredient.toString():
                allergyReportData = `<div style="${printClass.reportLeft1}">${monograph}</div>`;
                break;
            case allergyMonographType.IngredientBased.toString():
                allergyReportData = `<div style="${printClass.reportLeft2}">${monograph}</div>`;
                break;

        }
        return allergyReportData;
    }
</script>
<style scoped> 
.interaction-header {
    color: black;
}
.interacton-detail2 {
  padding-left: 1rem !important;
}
.interacton-detail3 {
  padding-left: 1.5rem !important;
}
</style>

<template> 
    <div class="row pt-2"> 
        <div v-if="formData.drugErrorMessage" class="col"> 
            {{ formData.drugErrorMessage }}
        </div>
        <div v-if="!formData.drugErrorMessage" class="col"> 
            <div class="row"> 
                <div class="col skinnyscroll " :style="{'overflow-y': 'scroll', 'overflow-x': 'hidden', 'height': (props.displayHeight + 'px')}"> 
                    <div v-for="allergyRecord in formData.allergyList"> 
                        <div v-if="allergyRecord.monographType === allergyMonographType.Allergen.toString()" class="interaction-header fs-6 ">  
                            <em :class="getSeverityClass(severityLevel.Contraindicated)"></em>
                            <span class="ps-2">{{allergyRecord.monograph}}</span>
                        </div>
                        <div v-if="allergyRecord.monographType === allergyMonographType.Ingredient.toString()" class="text-muted interacton-detail2"> 
                            {{allergyRecord.monograph}}
                        </div>
                        <div v-if="allergyRecord.monographType === allergyMonographType.IngredientBased.toString()" class="text-muted interacton-detail3"> 
                            {{allergyRecord.monograph}}
                        </div>
                    </div>  
                </div>
            </div>
        </div>
    </div>
</template>